import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./HomePage";
import ProductDetail from "./ProductDetail";
import Page from "./Page";
import NotFound from "./NotFound";

function App() {
  return (
    <Router>
      <Routes>
        {/* Route for the HomePage */}
        <Route path="/" element={<HomePage />} />

        {/* Route for individual Product Detail page */}
        <Route path="/product/:slug" element={<ProductDetail />} />

        {/* Datenschutzerklärung (privacy policy), CMS-driven */}
        <Route path="/datenschutz" element={<Page slug="privacy-policy" />} />

        {/* Catch-all route for 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
